export const NEWS_CATEGORIES = [
  {
    text: 'Marketing, Comunicazione, Digital e Social media',
    value: 'Marketing Comunicazione Digital e Social Media',
  },
  {
    text: 'Gestione di Impresa, Export e Internazionalizzazione',
    value: 'Gestione di Impresa Export e Internazionalizzazione',
  },
  { 
    text: 'HR, Lavoro e Sviluppo Manageriale', 
    value: 'HR Lavoro e Sviluppo Manageriale' 
  },
  { 
    text: 'Amministrazione, finanza e Controllo', 
    value: 'Amministrazione Finanza e Controllo' 
  },
  { 
    text: 'Lusso e Moda', 
    value: 'Lusso e Moda' 
  },
  { 
    text: 'Vendite e Retail', 
    value: 'Vendite e Retail' 
  },
  { 
    text: 'Ambiente Energia e P.A.', 
    value: 'Ambiente Energia e P.A.' 
  },
  { 
    text: 'Sanità, Pharma e Biomed', 
    value: 'Sanità Pharma e Biomed' 
  },
  { 
    text: 'Arte, cinema e Design',
    value: 'Arte Cinema e Design' 
  },
  { 
    text: 'Diritto e fisco', 
    value: 'Diritto e Fisco' 
  },
  { 
    text: 'Food, Beverage e Turismo', 
    value: 'Food Beverage e Turismo' 
  },
  { 
    text: 'Sport', 
    value: 'Sport' 
  },
  { 
    text: 'Brand', 
    value: 'Brand' 
  },
  { 
    text: 'Formazione', 
    value: 'Formazione' 
  },
];